import { useEffect, useRef, useState } from "react";
import { HiArrowUp } from "react-icons/hi";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const scrollElRef = useRef(null);

  useEffect(() => {
    const findScrollParent = () => {
      // Prefer the element that actually scrolls
      const candidates = [
        document.querySelector("[data-scroll-container='true']"),
        document.querySelector("#root"),
        document.documentElement,
        document.body,
      ].filter(Boolean);

      // Find first candidate that can scroll
      for (const el of candidates) {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const canScroll =
          (overflowY === "auto" || overflowY === "scroll") &&
          el.scrollHeight > el.clientHeight;

        if (canScroll) return el;
      }

      // fallback to window scroll
      return window;
    };

    const target = findScrollParent();
    scrollElRef.current = target;

    const getScrollTop = () =>
      target === window ? window.scrollY : target.scrollTop;

    const onScroll = () => setVisible(getScrollTop() >= 300);

    target.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => target.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const target = scrollElRef.current || window;

    if (target === window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      target.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="
        fixed bottom-6 right-6 z-[999999]
        p-3 rounded-xl
        bg-[#0b2b40] text-white
        shadow-lg transition-all duration-200
        hover:opacity-95 hover:shadow-xl
        active:scale-95
      "
    >
      <HiArrowUp className="text-xl" />
    </button>
  );
}
